import React from "react"
import styled, { keyframes } from "styled-components"
import { AngleDownIcon } from "client/components"

export type TooltipAlignType = "center" | "left" | "right"
const OverflowDelay = keyframes`
    from { overflow: hidden; }
`


export const DescriptionWrapper = styled.div<{
    show: boolean
}>`
    max-height: ${(props) => (props.show ? "unset" : "112px")};
    overflow: hidden;
`


const CollapseDescriptionButton = styled.div`
    height: 23px;
    width: 65px;
    text-align: center;
    background: ${(props) => props.theme.commentBackgroundColor};
    border: 1px solid ${(props) => props.theme.commentCollapseDescriptionBorderColor};
    transform: translateY(2px);
    border-bottom: none;
    border-radius: 16px 16px 0 0;
    transition: 0.2s;
`
const CollapseDescriptionButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    left: 12px;
    height: 25px;
    width: calc(100% - 24px);
    transform: translateY(-14px);
    background: ${(props) => props.theme.commentCollapseDescriptionBackground};
    border-bottom: 1px solid ${(props) => props.theme.commentCollapseDescriptionBorderColor};
    transition: 0.2s;

    &:hover {
        border-color: ${(props) => props.theme.commentCollapseDescriptionBorderHoverColor};

        & > ${CollapseDescriptionButton} {
            border-color: ${(props) => props.theme.commentCollapseDescriptionBorderHoverColor};
        }
    }
`
type CollapseDescriptionProps = {
    onClick: () => void
}
export const CollapseDescription = ({
    onClick,
}: CollapseDescriptionProps) => (
    <CollapseDescriptionButtonWrapper onClick={onClick}>
        <CollapseDescriptionButton>
            <AngleDownIcon />
        </CollapseDescriptionButton>
    </CollapseDescriptionButtonWrapper>
)


export const AttachmentManagerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding: 12px 10px 10px;
    background: #ffffff; // use color of editor body
    transform: translateY(-8px);
`
export const AttachmentManagerButtonSubtext = styled.div<{
    show: boolean
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    padding: 0px 6px;
    margin-left: 2px;
    height: 12px;
    border-radius: 8px;
    transform: translateY(-6px);
    color: #ffffff; // color of editor body
    background: ${(props) => (props.show
        ? props.theme.attachmentBlockManagerButtonHoverColor
        : props.theme.attachmentBlockManagerButtonColor)};
    transition: 0.2s;
`
export const AttachmentManagerButton = styled.div<{
    show: boolean
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    color: ${(props) => (props.show ? "black" : props.theme.attachmentBlockManagerButtonColor)};
    user-select: none;
    transition: 0.2s;

    & > i {
        margin-right: 5px;
        font-size: 18px;
        color: ${(props) => (props.show
        ? props.theme.attachmentBlockManagerButtonHoverColor
        : props.theme.attachmentBlockManagerButtonColor)};
        transition: 0.2s;
    }

    &:hover {
        color: black; // use color of editor text

        & ${AttachmentManagerButtonSubtext} {
            background: ${(props) => props.theme.attachmentBlockManagerButtonHoverColor};
        }

        & > i {
            color: ${(props) => props.theme.attachmentBlockManagerButtonHoverColor};
        }
    }
`


export const AttachmentBlockWrapper = styled.div<{
    show: boolean
}>`
    display: flex;
    flex-direction: column;
    padding: ${(props) => (props.show ? "10px 10px 0" : "0px")};
    height: ${(props) => (props.show ? "fit-content" : "0px")};
    overflow: ${(props) => (props.show ? "visible" : "hidden")};
    transform: translateY(-8px);
    background: ${(props) => props.theme.attachmentBlockBackgroundColor};
`
export const AttachmentListWrapper = styled.div`
    display: flex;
    flex-direction: row;
`
export const Tooltip = styled.div<{
    align: TooltipAlignType
}>`
    position: absolute;
    padding: 8px 12px;
    white-space: nowrap;
    border-radius: 4px;
    transform: ${(props) => {
        if (props.align === "center") return "translate(calc(-50% + 16px), calc(-100% - 30px))"
        if (props.align === "left") return "translate(0, calc(-100% - 30px))"
        if (props.align === "right") return "translate(calc(-100% + 34px),calc(-100% - 30px))"
        return ""
    }};
    background: ${(props) => props.theme.tooltipBackground};
    color: ${(props) => props.theme.tooltipColor};
    opacity: 0;
    transition: all 0.1s ease 0.2s;
    pointer-events: none;

    &:after {
        content: "";
        display: block;
        position: absolute;
        top: 100%;
        left: ${(props) => {
        if (props.align === "center") return "calc(50% - 6px)"
        if (props.align === "left") return "12px"
        if (props.align === "right") return "calc(100% - 24px)"
        return ""
    }};
        border: 6px solid transparent;
        border-top-color: ${(props) => props.theme.tooltipBackground};
        transition: all 0.1s ease 0.2s;
    }
`
const AttachmentButton = styled.div`
    position: absolute;
    top: 2px;
    text-align: center;
    background: ${(props) => props.theme.attachmentBackgroundColor};

    &:hover {
        & ${Tooltip} {
            opacity: 1;
        }
    }
`
export const DeleteAttachment = styled(AttachmentButton)`
    width: 32px;
    left: -32px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 12px;
    color: lightgrey;
    transition: left 0.3s, color 0.2s;

    & > i {
        font-weight: bold;
        font-size: 12px;
    }

    &:hover {
        color: dimgrey;
    }
`
export const AddToTextAttachment = styled(AttachmentButton)<{
    inText: boolean
}>`
    width: 38px;
    right: -38px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 12px;
    color: ${(props) => (props.inText ? props.theme.attachmentInTextColor : "lightgrey")};
    transition: right 0.3s, color 0.2s;

    & > i {
        font-size: 11px;
        margin-right: 5px;
    }

    &:hover {
        color: ${(props) => (props.inText ? props.theme.attachmentInTextColor : "dimgrey")};
    }
`
export const AttachmentWrapper = styled.div<{
    inText: boolean
    viewMode?: boolean
}>`
    position: relative;
    display: flex;
    flex-direction: column;
    height: ${(props) => (props.viewMode ? "82px" : "122px")};
    width: ${(props) => (props.viewMode ? "80px" : "120px")};
    padding: 3px;
    margin: 4px 10px 15px;
    overflow: hidden;
    border-radius: 12px;
    background: ${(props) => props.theme.attachmentBackgroundColor};
    box-shadow: ${(props) => (props.inText ? props.theme.attachmentInTextBoxShadow : "none")};
    transition: box-shadow 0.3s;
    cursor: pointer;

    &:hover {
        animation: ${OverflowDelay} 1s;
        overflow: visible; // to enable custom tooltip on hover buttons
        box-shadow: ${(props) => (props.inText
        ? props.theme.attachmentInTextBoxShadow
        : props.theme.attachmentHoverBoxShadow)};

        & ${DeleteAttachment} {
            left: 0;
        }

        & ${AddToTextAttachment} {
            right: 0;
        }
    }
`
export const AttachmentLogo = styled.div<{
    backgroundSrc: string
    fileType: string
}>`
    width: 100%;
    display: flex;
    flex-grow: 1;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: ${(props) => (props.fileType.indexOf("image") >= 0 ? "cover" : "75%")};
    background-image: ${(props) => `url(${props.backgroundSrc})`};
`
export const AttachmentTitle = styled.div<{
    viewMode?: boolean
}>`
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: ${(props) => (props.viewMode ? 2 : 3)};
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${(props) => props.theme.attachmentTextColor};
    font-size: 12px;
    line-height: 13px;
    padding: 4px 6px 0 6px;
    text-align: center;
`
